import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
var mixinDetictingMobile = {
  methods: {
    isMobile() {
      if("/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i".test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
   }
}

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
  mixins: [mixinDetictingMobile]
}).$mount('#app')

